import api from '.'

export const promis = {
  // Form catalogue
  listForms (success, fail) {
    api.authenticatedRequest('GET', '/promis/forms', null, success, fail)
  },
  getForm (oid, success, fail) {
    api.authenticatedRequest('GET', `/promis/forms/${oid}`, null, success, fail)
  },
  getInterpretation (oid, success, fail) {
    api.authenticatedRequest('GET', `/promis/forms/${oid}/interpretation`, null, success, fail)
  },

  // Battery catalogue
  listBatteries (success, fail) {
    api.authenticatedRequest('GET', '/promis/batteries', null, success, fail)
  },
  getBattery (oid, success, fail) {
    api.authenticatedRequest('GET', `/promis/batteries/${oid}`, null, success, fail)
  },

  // Sessions
  startSession (dataTypeId, data, success, fail) {
    api.authenticatedRequest('POST', `/promis/data-types/${dataTypeId}/sessions`, data, success, fail)
  },
  getSession (dataTypeId, sessionId, data, success, fail) {
    api.authenticatedRequest('GET', `/promis/data-types/${dataTypeId}/sessions/${sessionId}${data?.accessToken ? `?accessToken=${encodeURIComponent(data.accessToken)}` : ''}`, null, success, fail)
  },
  submitResponse (dataTypeId, sessionId, data, success, fail) {
    api.authenticatedRequest('POST', `/promis/data-types/${dataTypeId}/sessions/${sessionId}/responses`, data, success, fail)
  },

  // Battery scoring (PROPr) — data.sessions is [{ id, accessToken }]
  scoreBattery (dataTypeId, data, success, fail) {
    api.authenticatedRequest('POST', `/promis/data-types/${dataTypeId}/battery-sessions`, data, success, fail)
  },
  getBatterySession (dataTypeId, batterySessionId, data, success, fail) {
    api.authenticatedRequest('GET', `/promis/data-types/${dataTypeId}/battery-sessions/${batterySessionId}${data?.accessToken ? `?accessToken=${encodeURIComponent(data.accessToken)}` : ''}`, null, success, fail)
  }
}
